module.exports = __webpack_public_path__ + "dashboard/img/question.d3a4d46143365151c8faff1189a3cbcb.svg";